import {CalculatorBase} from "./CalculatorBase";
import {NumericUtilities} from "../../Utilities/NumericUtilities";
import {PriceManager} from "FormBuilder/Utilities/Managers/PriceManager/PriceManager";

export class GroupOfFieldsInGroupCalculator extends CalculatorBase{

    private CustomSalePrice:number;
    private CustomRegularPrice:number;

    constructor(public PriceManager:PriceManager) {
        super();
        this.CustomSalePrice=null;
        this.CustomRegularPrice=null;
        this.PriceManager.TotalUpdated.Subscribe(this,()=>this.ExecuteAndUpdate());
    }


    public SetRegularPrice(price:any)
    {
        this.CustomRegularPrice=price;
        return this;
    }

    public SetSalePrice(price:any)
    {
        this.CustomSalePrice=price;
        return this;
    }

    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}   {
        if(value==null)
            value=this.Field.GetValue();


        let regularPrice=0;
        let salePrice='';
        let quantity=this.GetQuantityInput();

        for(let repeaterItem of value)
            for(let field of repeaterItem)
            {
                regularPrice+=field.Price;
            }


        return {
            Quantity:this.GetQuantityInput(),
            RegularPrice:regularPrice,
            SalePrice:''
        }
    }





    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

}